import ShopifyBuy from '@shopify/buy-button-js'

const shopifyClient = ShopifyBuy.buildClient({
    domain: 'startupguide.myshopify.com',
    storefrontAccessToken: 'ad0c27b93901805e384cd187b1bce255',
})

const shopifyUI = ShopifyBuy.UI.init(shopifyClient)

export default shopifyUI
